import React from 'react';
import classnames from 'classnames';

const IconOnlyButton = ({
  borderless,
  primary,
  children,
  onClick,
  disabled,
  size,
}) => {
  const classes = classnames('c-icon-only-button', {
    'c-icon-only-button--primary': primary,
    'c-icon-only-button--borderless': borderless,
    'c-icon-only-button--size-x-small': size === 'x-small',
    'c-icon-only-button--size-small': size === 'small',
  });
  return (
    <button className={classes} onClick={onClick} disabled={disabled === true}>
      {children}
    </button>
  );
};

export default IconOnlyButton;
